import { Link } from "@tanstack/react-router";
import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Παιχνιδιάρικο banner που προωθεί τα έτοιμα θεματικά πακέτα MrBox.
 * Τοποθετείται στην αρχική σελίδα ανάμεσα στις Νέες Αφίξεις και τις
 * Δημοφιλείς Κατηγορίες.
 */
export function MrBoxBanner({ className }: { className?: string }) {
  return (
    <section className={cn("px-4 py-2", className)}>
      <Link
        to="/mrbox"
        aria-label="Δες τα έτοιμα πακέτα MrBox"
        className="group relative block overflow-hidden rounded-3xl bg-gradient-to-br from-primary to-primary-strong p-6 shadow-lg transition-transform hover:scale-[1.01] focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
      >
        <span
          aria-hidden
          className="absolute -right-4 -top-6 text-7xl opacity-20 motion-safe:animate-bob"
        >
          🎁
        </span>
        <span
          aria-hidden
          className="absolute -left-4 bottom-2 text-6xl opacity-15 motion-safe:animate-bob"
          style={{ animationDelay: "1s" }}
        >
          🐼
        </span>
        <span
          aria-hidden
          className="absolute right-1/3 top-1/2 text-4xl opacity-10 motion-safe:animate-bob"
          style={{ animationDelay: "0.5s" }}
        >
          ✨
        </span>

        <div className="relative flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
          <div className="max-w-xl">
            <div className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-primary-foreground/15 px-3 py-1 text-xs font-semibold text-primary-foreground backdrop-blur-sm">
              <Sparkles className="h-3.5 w-3.5" />
              Έκπτωση έως 8%
            </div>
            <h2 className="text-2xl font-extrabold leading-tight text-primary-foreground sm:text-3xl">
              Έτοιμα πακέτα MrBox
            </h2>
            <p className="mt-2 max-w-md text-sm text-primary-foreground/90">
              Ο MrPanda ετοιμάζει για σένα θεματικά κουτιά με προϊόντα που
              ταιριάζουν — από καφέ και σνακ μέχρι σχολικά και σπίτι.
            </p>
          </div>

          <div className="flex shrink-0 items-center gap-3">
            <span
              aria-hidden
              className="hidden text-4xl motion-safe:animate-bob sm:block"
              style={{ animationDelay: "1.5s" }}
            >
              📦
            </span>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-foreground px-5 py-3 text-sm font-bold text-primary shadow-md transition-colors group-hover:bg-background">
              Δες τα MrBox
              <span aria-hidden>→</span>
            </span>
          </div>
        </div>
      </Link>
    </section>
  );
}
